import * as React from 'react';
export const northwestbankSvg = React.forwardRef(function northwestbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#008752',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26 24.749V7.25A1.25 1.25 0 0 0 24.748 6c-4.039 0-8.184 1.616-11.292 4.14l4.853 6.186V10.14h3.215v11.7h-2.839l-5.005-6.42v6.42h-3.224v-8.78C7.737 16.335 6.01 20.485 6.01 24.739c0 .691.56 1.25 1.251 1.25h17.487A1.25 1.25 0 0 0 26 24.74v.01Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 24.749v-.957c.326-4.313 1.668-8.88 4.466-12.075V10.15h1.628c3.174-2.594 7.568-3.835 11.719-4.14H7.25A1.25 1.25 0 0 0 6 7.261V24.75Z',
      fill: '#fff',
    }),
  );
});
northwestbankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var northwestbank = {
  category: 'brand',
  colorable: false,
  name: 'northwestbank',
  svg: northwestbankSvg,
};
